import { call, put, takeLatest } from 'redux-saga/effects'
import { projectService } from '../../services/projectService'
import {
    ProjectActionTypes,
    getProjectsSuccess,
    getProjectsFailure,
    createProjectSuccess,
    createProjectFailure,
    getProjectDetailsSuccess,
    getProjectDetailsFailure,
} from '../actions/projectActions'

function* getProjectsSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(projectService.getProjects, action.payload)
        // The response data contains a 'data' object which has the 'data' array from pagination
        const projects = response.data.data || response.data
        yield put(getProjectsSuccess(projects))
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Failed to fetch projects'
        yield put(getProjectsFailure(errorMessage))
    }
}

function* getProjectDetailsSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(projectService.getProject, action.payload)
        yield put(getProjectDetailsSuccess(response.data))
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Failed to fetch project details'
        yield put(getProjectDetailsFailure(errorMessage))
    }
}

function* createProjectSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(projectService.createProject, action.payload)
        yield put(createProjectSuccess(response.data))
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Failed to create project'
        yield put(createProjectFailure(errorMessage))
    }
}

export function* watchProjectSagas() {
    yield takeLatest(ProjectActionTypes.GET_PROJECTS_REQUEST, getProjectsSaga)
    yield takeLatest(ProjectActionTypes.GET_PROJECT_DETAILS_REQUEST, getProjectDetailsSaga)
    yield takeLatest(ProjectActionTypes.CREATE_PROJECT_REQUEST, createProjectSaga)
}
